<template>
    <rkm-form
        ref="RkmForm"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="data.form.encaminhamentoEspecialidades"
                    :validations="validations.ocupacaoId"
                    label="Especialidade médica"
                    text-field="nome"
                    v-model="model.ocupacao.id"
                    value-field="id"
                    show-default-option
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>
                            <rkm-form-checkbox
                                inline
                                v-model="model.urgente"
                            >
                                Urgente
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-select>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    disabled
                    label="Hipótese / Diagnóstico (CID10)"
                    :value="getCID()"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.motivo"
                    label="Motivo do encaminhamento"
                    v-model="model.motivo"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.observacoes"
                    label="Observações"
                    v-model="model.observacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                ocupacaoId: { required: true },
                motivo: { required: true, min: 1, max: 300 },
                observacoes: { min: 1, max: 300 },
            }
        },
    },
    methods: {
        getCID() {
            return this.data.model.cid ? this.data.model.cid.nome : ''
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    const duplicado = this.data.model.encaminhamentos.find(item => {
                        if (item.id !== this.model.id) {
                            return item.ocupacao.id === this.model.ocupacao.id
                        }

                        return false
                    })

                    if (duplicado) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Encaminhamento já incluído para essa especialidade médica!'
                        })
                    } else {
                        const ocupacao = this.data.form.encaminhamentoEspecialidades.find(item => item.id === this.model.ocupacao.id)

                        this.model.ocupacao = Object.assign({}, {
                            id: ocupacao.id,
                            nome: ocupacao.nome,
                        })

                        if (this.model.id) {
                            const index = this.data.model.encaminhamentos.findIndex(item => item.id === this.model.id)
                            Object.assign(this.data.model.encaminhamentos[index], this.model)
                        } else {
                            this.model.id = this.uniqueId('pronto-atendimento-atendimento-medico-encaminhamento')
                            this.data.model.encaminhamentos.push(this.model)
                        }

                        this.$emit('saved', this.model)
                    }
                }
            })
        },
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>